
import React from 'react';

interface MapErrorDisplayProps {
  error: string;
}

const MapErrorDisplay: React.FC<MapErrorDisplayProps> = ({ error }) => {
  return (
    <div className="h-full w-full flex items-center justify-center">
      <div className="bg-background/80 backdrop-blur-sm p-6 rounded-lg shadow-lg border text-center max-w-md">
        <p className="text-destructive font-medium mb-2 break-words">Map Error</p>
        <p className="text-muted-foreground break-words">{error}</p>
      </div>
    </div>
  );
};

export default MapErrorDisplay;
